export interface Option {
  id: string;
  name: string;
  ruName: string;
}

export enum OptionFormType {
  add = 'add',
  edit = 'edit',
  remove = 'remove',
}
